export const RESUME_PDF = "/curriculo-fagner-nunes.pdf";

export const LINKS = {
  email: "fagnernunes.dev@gmail.com",
  phonePrimary: "(11) 94716-5462",
  phoneSecondary: "(11) 96758-9484",
  github: "https://github.com/fagnernunes",
  githubLabel: "github.com/fagnernunes",
  location: "Ferraz de Vasconcelos — SP, Brasil",
};

export const SKILLS = [
  { name: "JavaScript", tag: "core", span: "md:col-span-4 md:row-span-2" },
  { name: "TypeScript", tag: "core", span: "md:col-span-4" },
  { name: "React.js", tag: "frontend", span: "md:col-span-4" },
  { name: "Next.js", tag: "frontend", span: "md:col-span-4" },
  { name: "PHP", tag: "backend", span: "md:col-span-4" },
  { name: "MySQL", tag: "database", span: "md:col-span-4" },
  { name: "Tailwind", tag: "styling", span: "md:col-span-3" },
  { name: "REST API", tag: "backend", span: "md:col-span-3" },
  { name: "Node.js", tag: "backend", span: "md:col-span-3" },
  { name: "jQuery", tag: "frontend", span: "md:col-span-3" },
  { name: "MVC", tag: "architecture", span: "md:col-span-3" },
  { name: "Liferay", tag: "cms", span: "md:col-span-3" },
  { name: "Storybook", tag: "tooling", span: "md:col-span-3" },
  { name: "Git", tag: "vcs", span: "md:col-span-2" },
  { name: "Github", tag: "vcs", span: "md:col-span-2" },
  { name: "Bitbucket", tag: "vcs", span: "md:col-span-2" },
  { name: "Jenkins", tag: "ci/cd", span: "md:col-span-2" },
];

export const MARQUEE_SKILLS = [
  "JavaScript",
  "TypeScript",
  "React",
  "Next.js",
  "PHP",
  "MySQL",
  "Tailwind",
  "REST",
  "Liferay",
  "Storybook",
  "Jenkins",
  "Git",
];

export const CONTENT = {
  pt: {
    nav: {
      about: "Sobre",
      skills: "Skills",
      experience: "Experiência",
      education: "Formação",
      contact: "Contato",
      download: "Baixar CV",
    },
    hero: {
      overline: "Full-stack Developer",
      name1: "Fagner da",
      name2: "Costa Nunes",
      tagline:
        "Construo interfaces rápidas e escaláveis com React, Next.js e TypeScript. Do design system ao deploy.",
      status: "",
      cta1: "Ver experiência",
      cta2: "Baixar currículo",
      scroll: "role para explorar",
    },
    about: {
      num: "01",
      label: "Sobre",
      title: "Desenvolvedor Full-stack",
      p1: "Olá! Sou Fagner Nunes, tenho 24 anos e moro em Ferraz de Vasconcelos - SP. Atualmente, atuo como Desenvolvedor Front-end na SKY Brasil, onde lidero a arquitetura do monorepositório corporativo. Sou responsável por centralizar e evoluir nosso Design System e a biblioteca de componentes reutilizáveis baseada em Storybook, garantindo escalabilidade, consistência visual e alta performance para múltiplos produtos da empresa.",
      p2: "Minha trajetória inclui experiência sólida como Desenvolvedor Full-stack, construindo aplicações web com PHP (MVC), JavaScript, MySQL e APIs REST, além de desenvolver scripts de automação em Python.",
      p3: "Sou formado em Análise e Desenvolvimento de Sistemas, curto código e café.",
      stats: [
        { value: "3+", label: "anos de experiência" },
        { value: "15+", label: "tecnologias" },
        { value: "∞", label: "curiosidade" },
      ],
      education: "Formação",
    },
    education: {
      num: "02",
      label: "Formação",
      title: "Cursos & formações",
      sub: "Aprendizado contínuo — da graduação aos cursos técnicos e especializações.",
      cats: { degree: "Graduação", course: "Curso", technical: "Técnico" },
      concluded: "Concluído",
    },
    skills: {
      num: "03",
      label: "Skills",
      title: "Stack & ferramentas",
      sub: "As tecnologias que uso para transformar ideias em produtos.",
    },
    experience: {
      num: "04",
      label: "Experiência",
      title: "Trajetória profissional",
      present: "Atual",
      items: [
        {
          role: "Desenvolvedor Front-end",
          company: "SKY",
          period: "09/2024 — Atual",
          desc: "Desenvolvimento de soluções com React.js, Next.js, TypeScript, Tailwind, Liferay e Storybook. Responsável pelo monorepositório que centraliza o Design System e o versionamento de componentes reutilizáveis, garantindo padronização e escalabilidade entre múltiplos projetos.",
          stack: [
            "React.js",
            "Next.js",
            "TypeScript",
            "Tailwind",
            "Liferay",
            "Storybook",
            "Jenkins",
          ],
        },
        {
          role: "Desenvolvedor Full-stack Jr",
          company: "Escala Web",
          period: "08/2023 — 08/2024",
          desc: "Atuação full-stack no desenvolvimento de sites e sistemas web com PHP, JavaScript (jQuery), MySQL e REST API na estrutura MVC. Contribuí com melhorias criando extensões e automação de tarefas.",
          stack: ["PHP", "JavaScript", "jQuery", "MySQL", "REST API", "MVC"],
        },
      ],
    },
    contact: {
      num: "05",
      label: "Contato",
      big1: "Vamos",
      big2: "conversar",
      sub: "Aberto a novas oportunidades como desenvolvedor full-stack. Me chame para um café virtual.",
      download: "Baixar currículo (PDF)",
      rights: "Feito com café e código.",
    },
  },
  en: {
    nav: {
      about: "About",
      skills: "Skills",
      experience: "Experience",
      education: "Education",
      contact: "Contact",
      download: "Resume",
    },
    hero: {
      overline: "Full-stack Developer",
      name1: "Fagner da",
      name2: "Costa Nunes",
      tagline:
        "I build fast, scalable interfaces with React, Next.js and TypeScript — from design system to deploy.",
      status: "",
      cta1: "View experience",
      cta2: "Download resume",
      scroll: "scroll to explore",
    },
    about: {
      num: "01",
      label: "About",
      title: "A full-stack developer focused on product and experience.",
      p1: "I'm 24, based in Ferraz de Vasconcelos, Brazil. I currently work as a Front-end Developer at SKY, where I own the monorepo that centralizes the Design System and versioning of reusable components — serving multiple projects and business areas with standardization, scalability and efficiency.",
      p2: "Before that, I worked as a full-stack developer building websites and web systems with PHP, JavaScript and MySQL in an MVC structure, creating extensions and automations. I hold a degree in Systems Analysis & Development and I'm curious by nature.",
      stats: [
        { value: "3+", label: "years of experience" },
        { value: "15+", label: "technologies" },
        { value: "∞", label: "curiosity" },
      ],
      education: "Education",
    },
    skills: {
      num: "03",
      label: "Skills",
      title: "Stack & tools",
      sub: "The technologies I use to turn ideas into products.",
    },
    experience: {
      num: "04",
      label: "Experience",
      title: "Professional journey",
      present: "Present",
      items: [
        {
          role: "Front-end Developer",
          company: "SKY",
          period: "09/2024 — Present",
          desc: "Building solutions with React.js, Next.js, TypeScript, Tailwind, Liferay and Storybook. Owner of the monorepo that centralizes the Design System and versioning of reusable components, ensuring standardization and scalability across multiple projects.",
          stack: [
            "React.js",
            "Next.js",
            "TypeScript",
            "Tailwind",
            "Liferay",
            "Storybook",
            "Jenkins",
          ],
        },
        {
          role: "Full-stack Developer Jr",
          company: "Escala Web",
          period: "08/2023 — 08/2024",
          desc: "Full-stack work building websites and web systems with PHP, JavaScript (jQuery), MySQL and REST API in an MVC structure. Contributed improvements by creating extensions and task automation.",
          stack: ["PHP", "JavaScript", "jQuery", "MySQL", "REST API", "MVC"],
        },
      ],
    },
    education: {
      num: "02",
      label: "Education",
      title: "Courses & education",
      sub: "Continuous learning — from my degree to technical courses and specializations.",
      cats: { degree: "Degree", course: "Course", technical: "Technical" },
      concluded: "Completed",
    },
    contact: {
      num: "05",
      label: "Contact",
      big1: "Let's",
      big2: "talk",
      sub: "Open to new opportunities as a full-stack developer. Reach out for a virtual coffee.",
      download: "Download resume (PDF)",
      rights: "Made with coffee and code.",
    },
  },
};

export const EDUCATION = [
  {
    title: "Análise e Desenvolvimento de Sistemas",
    org: "Wyden",
    year: "2025",
    cat: "degree",
  },
  { title: "REST API", org: "Ada Tech", year: "2024", cat: "course" },
  { title: "Front-end", org: "Ada Tech", year: "2024", cat: "course" },
  { title: "POO PHP", org: "Curso em Vídeo", year: "2023", cat: "course" },
  {
    title: "Desenvolvedor de Páginas Web",
    org: "SENAI",
    year: "2021",
    cat: "technical",
  },
  { title: "Design UI & UX", org: "SENAI", year: "2021", cat: "technical" },
  {
    title: "Manutenção e Configuração de Computadores",
    org: "SENAI",
    year: "2021",
    cat: "technical",
  },
];
